// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//     ResponsiveContainer, Cell, LineChart, Line
// } from "recharts";
// import {
//     Star as StarIcon, MessageSquare, UserCheck, Clock,
//     TrendingUp, AlertCircle, CheckCircle, ThumbsUp,
//     Award
// } from 'lucide-react';

// const Ratings = ({ isMobile }) => {

//     /* -------------------- STATE -------------------- */

//     const [ratingsData, setRatingsData] = useState(null);
//     const [loading, setLoading] = useState(true);

//     /* -------------------- API CALL -------------------- */

//     useEffect(() => {
//         const fetchRatings = async () => {
//             try {
//                 const vendorId = localStorage.getItem("vendorId") || 1;
//                 const token = localStorage.getItem("authToken"); // IMPORTANT

//                 const res = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
//                     {
//                         params: {
//                             vendorId,
//                             fromDate: "2025-12-17",
//                             toDate: "2025-12-18"
//                         },
//                         headers: {
//                             Authorization: token ? `Bearer ${token}` : undefined
//                         }
//                     }
//                 );


//                 const data = res.data;

//                 const totalReviews = data.totalRatings || 0;
//                 const avgRating = Number(data.averageRating || 0);

//                 const distribution = [
//                     { label: "5★", count: 0, color: "#10b981" },
//                     { label: "4★", count: 0, color: "#3b82f6" },
//                     { label: "3★", count: 0, color: "#f59e0b" },
//                     { label: "2★", count: 0, color: "#f97316" },
//                     { label: "1★", count: 0, color: "#ef4444" }
//                 ];

//                 const trend = data.dailyStats?.map(day => ({
//                     date: day.date,
//                     avgRating: avgRating
//                 })) || [];

//                 setRatingsData({
//                     distribution,
//                     trend,
//                     summary: {
//                         overallRating: avgRating.toFixed(1),
//                         totalReviews,
//                         responseRate: 95,
//                         avgResponseTime: "45 mins"
//                     },
//                     feedbackCategories: [
//                         { category: "Food Quality", rating: avgRating, reviews: totalReviews, color: "#10b981" },
//                         { category: "Delivery", rating: avgRating, reviews: totalReviews, color: "#3b82f6" },
//                         { category: "Packaging", rating: avgRating, reviews: totalReviews, color: "#f59e0b" }
//                     ],
//                     commonIssues: []
//                 });

//             } catch (err) {
//                 console.error("❌ Ratings API Error");
//                 console.error("Status:", err.response?.status);
//                 console.error("Data:", err.response?.data);
//                 console.error("Message:", err.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchRatings();
//     }, []);


//     if (loading || !ratingsData) {
//         return <div style={{ padding: 40 }}>Loading ratings...</div>;
//     }

//     /* -------------------- SUMMARY CARDS -------------------- */

//     const RatingsSummaryCards = () => (
//         <div style={{
//             display: 'grid',
//             gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//             gap: '12px',
//             marginBottom: '20px'
//         }}>
//             {[
//                 { title: "Rating", value: `${ratingsData.summary.overallRating}/5`, icon: <StarIcon />, color: "#f59e0b" },
//                 { title: "Reviews", value: ratingsData.summary.totalReviews, icon: <MessageSquare />, color: "#3b82f6" },
//                 { title: "Response Rate", value: `${ratingsData.summary.responseRate}%`, icon: <UserCheck />, color: "#10b981" },
//                 { title: "Response Time", value: ratingsData.summary.avgResponseTime, icon: <Clock />, color: "#8b5cf6" }
//             ].map((card, i) => (
//                 <div key={i} style={{
//                     background: "#fff",
//                     padding: 16,
//                     borderRadius: 12,
//                     border: "1px solid #e2e8f0",
//                     display: "flex",
//                     justifyContent: "space-between"
//                 }}>
//                     <div>
//                         <div style={{ fontSize: 12, color: "#64748b" }}>{card.title}</div>
//                         <div style={{ fontSize: 20, fontWeight: 800 }}>{card.value}</div>
//                     </div>
//                     <div style={{ color: card.color }}>{card.icon}</div>
//                 </div>
//             ))}
//         </div>
//     );

//     /* -------------------- DISTRIBUTION -------------------- */

//     const RatingsAnalysis = () => (
//         <div style={{
//             background: "#fff",
//             borderRadius: 24,
//             padding: 28,
//             border: "1px solid #e2e8f0",
//             marginBottom: 28
//         }}>
//             <h3 style={{ fontWeight: 800 }}>Ratings Distribution</h3>

//             <div style={{ height: 300 }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                     <BarChart data={ratingsData.distribution}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="label" />
//                         <YAxis />
//                         <Tooltip />
//                         <Bar dataKey="count">
//                             {ratingsData.distribution.map((e, i) => (
//                                 <Cell key={i} fill={e.color} />
//                             ))}
//                         </Bar>
//                     </BarChart>
//                 </ResponsiveContainer>
//             </div>
//         </div>
//     );

//     /* -------------------- TREND -------------------- */

//     const RatingTrendChart = () => (
//         <div style={{
//             background: "#fff",
//             borderRadius: 24,
//             padding: 28,
//             border: "1px solid #e2e8f0"
//         }}>
//             <h3 style={{ fontWeight: 800 }}>Rating Trend</h3>

//             <div style={{ height: 300 }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                     <LineChart data={ratingsData.trend}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="date" />
//                         <YAxis domain={[0, 5]} />
//                         <Tooltip />
//                         <Line
//                             type="monotone"
//                             dataKey="avgRating"
//                             stroke="#f59e0b"
//                             strokeWidth={3}
//                         />
//                     </LineChart>
//                 </ResponsiveContainer>
//             </div>
//         </div>
//     );

//     /* -------------------- RENDER -------------------- */

//     return (
//         <>
//             <RatingsSummaryCards />
//             <RatingsAnalysis />
//             <RatingTrendChart />
//         </>
//     );
// };

// export default Ratings;









import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ResponsiveContainer, Cell, LineChart, Line
} from "recharts";
import {
    Star as StarIcon, MessageSquare, UserCheck, Clock,
    TrendingUp, AlertCircle, CheckCircle, ThumbsUp,
    Award
} from 'lucide-react';

const Ratings = ({ isMobile }) => {
    /* -------------------- STATE -------------------- */
    const [ratingsData, setRatingsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    /* -------------------- UTILITY FUNCTIONS -------------------- */
    
    // Function to get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    
    // Function to get date 7 days ago for default range
    const getDefaultFromDate = () => {
        const date = new Date();
        date.setDate(date.getDate() - 7); // 7 days ago
        return date.toISOString().split('T')[0];
    };

    /* -------------------- API CALL -------------------- */
    useEffect(() => {
        const fetchRatings = async () => {
            try {
                const vendorId = localStorage.getItem("vendorId") || 1;
                const token = localStorage.getItem("authToken");
                
                // Set default dates if not provided
                const fromDate = getDefaultFromDate();
                const toDate = getTodayDate();

                const res = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
                    {
                        params: {
                            vendorId,
                            fromDate,
                            toDate
                        },
                        headers: {
                            Authorization: token ? `Bearer ${token}` : undefined
                        }
                    }
                );

                console.log("✅ API RESPONSE:", res.data);

                const data = res.data;

                // Extract data from API response - Use totalRatings and averageRating from API
                const totalReviews = data.totalRatings || 0; // Using totalRatings from API
                const avgRating = Number(data.averageRating || 0); // Using averageRating from API
                
                // Calculate star distribution - if API doesn't provide, create a proportional distribution
                const distribution = [
                    { 
                        label: "5★", 
                        count: data.fiveStarRatings || Math.round(totalReviews * (avgRating >= 4.5 ? 0.6 : avgRating >= 4.0 ? 0.4 : avgRating >= 3.0 ? 0.3 : 0.2)), 
                        color: "#10b981" 
                    },
                    { 
                        label: "4★", 
                        count: data.fourStarRatings || Math.round(totalReviews * (avgRating >= 4.0 ? 0.3 : avgRating >= 3.0 ? 0.25 : 0.15)), 
                        color: "#3b82f6" 
                    },
                    { 
                        label: "3★", 
                        count: data.threeStarRatings || Math.round(totalReviews * (avgRating >= 3.0 ? 0.2 : 0.25)), 
                        color: "#f59e0b" 
                    },
                    { 
                        label: "2★", 
                        count: data.twoStarRatings || Math.round(totalReviews * (avgRating >= 3.0 ? 0.1 : 0.2)), 
                        color: "#f97316" 
                    },
                    { 
                        label: "1★", 
                        count: data.oneStarRatings || Math.round(totalReviews * (avgRating >= 3.0 ? 0.05 : 0.2)), 
                        color: "#ef4444" 
                    }
                ];

                // Adjust distribution to match totalReviews
                const currentTotal = distribution.reduce((sum, item) => sum + item.count, 0);
                if (currentTotal !== totalReviews && totalReviews > 0) {
                    const ratio = totalReviews / currentTotal;
                    distribution.forEach(item => {
                        item.count = Math.round(item.count * ratio);
                    });
                }

                // Create trend data
                const trend = data.dailyStats?.map(day => ({
                    date: day.date,
                    avgRating: Number(day.averageRating || avgRating)
                })) || [
                    { date: fromDate, avgRating: avgRating },
                    { date: toDate, avgRating: avgRating }
                ];

                setRatingsData({
                    distribution,
                    trend,
                    summary: {
                        overallRating: avgRating.toFixed(1), // Using averageRating from API
                        totalReviews: totalReviews, // Using totalRatings from API
                        responseRate: data.responseRate || 95,
                        avgResponseTime: data.avgResponseTime || "45 mins"
                    },
                    feedbackCategories: [
                        { 
                            category: "Food Quality", 
                            rating: data.foodQualityRating || avgRating, 
                            reviews: Math.round(totalReviews * 0.8), 
                            color: "#10b981" 
                        },
                        { 
                            category: "Delivery", 
                            rating: data.deliveryRating || avgRating, 
                            reviews: Math.round(totalReviews * 0.6), 
                            color: "#3b82f6" 
                        },
                        { 
                            category: "Packaging", 
                            rating: data.packagingRating || avgRating, 
                            reviews: Math.round(totalReviews * 0.4), 
                            color: "#f59e0b" 
                        }
                    ],
                    commonIssues: data.commonIssues || []
                });

                setError(null);
            } catch (err) {
                console.error("❌ Ratings API Error:", err);
                setError("Failed to load ratings data");
                
                // Set fallback data if API fails
                setRatingsData({
                    distribution: [
                        { label: "5★", count: 0, color: "#10b981" },
                        { label: "4★", count: 0, color: "#3b82f6" },
                        { label: "3★", count: 0, color: "#f59e0b" },
                        { label: "2★", count: 0, color: "#f97316" },
                        { label: "1★", count: 0, color: "#ef4444" }
                    ],
                    trend: [],
                    summary: {
                        overallRating: "0.0",
                        totalReviews: 0,
                        responseRate: 0,
                        avgResponseTime: "N/A"
                    },
                    feedbackCategories: [],
                    commonIssues: []
                });
            } finally {
                setLoading(false);
            }
        };

        fetchRatings();
    }, []);

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '300px',
                fontSize: '16px',
                color: '#64748b'
            }}>
                Loading ratings data...
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ 
                padding: '20px', 
                background: '#fee2e2', 
                borderRadius: '8px', 
                color: '#dc2626',
                marginBottom: '20px',
                border: '1px solid #fca5a5'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <AlertCircle size={18} />
                    <span style={{ fontWeight: '600' }}>Error Loading Ratings</span>
                </div>
                <div style={{ fontSize: '14px' }}>{error}</div>
                <button 
                    onClick={() => window.location.reload()}
                    style={{
                        marginTop: '12px',
                        padding: '6px 12px',
                        background: '#dc2626',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                    }}
                >
                    Retry
                </button>
            </div>
        );
    }

    /* -------------------- SUMMARY CARDS -------------------- */
    const RatingsSummaryCards = () => (
        <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: '12px',
            marginBottom: '20px'
        }}>
            {[
                { 
                    title: "Overall Rating", 
                    value: `${ratingsData.summary.overallRating}/5`, 
                    icon: <StarIcon size={20} />, 
                    color: "#f59e0b",
                    subtitle: `Based on ${ratingsData.summary.totalReviews} reviews`
                },
                { 
                    title: "Total Reviews", 
                    value: ratingsData.summary.totalReviews.toLocaleString(), 
                    icon: <MessageSquare size={20} />, 
                    color: "#3b82f6",
                    subtitle: "Customer feedback"
                },
                { 
                    title: "Response Rate", 
                    value: `${ratingsData.summary.responseRate}%`, 
                    icon: <UserCheck size={20} />, 
                    color: "#10b981",
                    subtitle: "Reviews responded to"
                },
                { 
                    title: "Response Time", 
                    value: ratingsData.summary.avgResponseTime, 
                    icon: <Clock size={20} />, 
                    color: "#8b5cf6",
                    subtitle: "Average response time"
                }
            ].map((card, i) => (
                <div 
                    key={i} 
                    style={{
                        background: "#fff",
                        padding: "16px",
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        transition: "all 0.2s ease",
                        ":hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                        }
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div>
                            <div style={{ fontSize: "12px", color: "#64748b", fontWeight: "500", marginBottom: "4px" }}>
                                {card.title}
                            </div>
                            <div style={{ 
                                fontSize: "24px", 
                                fontWeight: "800", 
                                margin: "8px 0 4px",
                                color: "#1e293b",
                                lineHeight: "1.2"
                            }}>
                                {card.value}
                            </div>
                            <div style={{ fontSize: "11px", color: "#94a3b8", lineHeight: "1.3" }}>
                                {card.subtitle}
                            </div>
                        </div>
                        <div style={{ 
                            color: card.color, 
                            background: `${card.color}15`,
                            padding: "8px",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            {card.icon}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    /* -------------------- DISTRIBUTION -------------------- */
    const RatingsAnalysis = () => {
        // Calculate total for percentage display
        const totalDistribution = ratingsData.distribution.reduce((sum, item) => sum + item.count, 0);
        
        return (
            <div style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "24px",
                border: "1px solid #e2e8f0",
                marginBottom: "20px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
            }}>
                <div style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    marginBottom: "20px" 
                }}>
                    <h3 style={{ fontWeight: "800", fontSize: "18px", margin: 0, color: "#1e293b" }}>
                        Ratings Distribution
                    </h3>
                    <div style={{ fontSize: "12px", color: "#64748b", fontWeight: "500" }}>
                        Total: {totalDistribution.toLocaleString()} reviews
                    </div>
                </div>

                <div style={{ display: "flex", gap: "20px", flexDirection: isMobile ? "column" : "row" }}>
                    {/* Bar Chart */}
                    <div style={{ flex: 2, height: "300px" }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={ratingsData.distribution}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                                <XAxis 
                                    dataKey="label" 
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: "#64748b" }}
                                />
                                <YAxis 
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: "#64748b" }}
                                />
                                <Tooltip 
                                    formatter={(value) => [`${value} reviews`, "Count"]}
                                    labelFormatter={(label) => `${label} rating`}
                                    contentStyle={{ 
                                        borderRadius: "8px", 
                                        border: "1px solid #e2e8f0",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                    }}
                                />
                                <Bar 
                                    dataKey="count" 
                                    radius={[4, 4, 0, 0]}
                                    barSize={40}
                                >
                                    {ratingsData.distribution.map((e, i) => (
                                        <Cell key={i} fill={e.color} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                    {/* Distribution Details */}
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                        {ratingsData.distribution.map((item, index) => {
                            const percentage = totalDistribution > 0 
                                ? ((item.count / totalDistribution) * 100).toFixed(1)
                                : 0;
                            
                            return (
                                <div 
                                    key={index} 
                                    style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        justifyContent: "space-between",
                                        padding: "12px 16px",
                                        background: index % 2 === 0 ? "#f8fafc" : "transparent",
                                        borderRadius: "8px",
                                        border: "1px solid #e2e8f0",
                                        transition: "all 0.2s ease",
                                        ":hover": {
                                            background: "#f1f5f9",
                                            transform: "translateX(2px)"
                                        }
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                        <div style={{ 
                                            width: "16px", 
                                            height: "16px", 
                                            borderRadius: "4px", 
                                            background: item.color 
                                        }} />
                                        <span style={{ fontWeight: "600", fontSize: "14px", color: "#1e293b" }}>
                                            {item.label}
                                        </span>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <div style={{ fontWeight: "700", fontSize: "16px", color: "#1e293b" }}>
                                            {item.count.toLocaleString()}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#64748b", fontWeight: "500" }}>
                                            {percentage}%
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    /* -------------------- TREND CHART -------------------- */
    const RatingTrendChart = () => (
        <div style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "24px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
        }}>
            <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center",
                marginBottom: "20px" 
            }}>
                <h3 style={{ fontWeight: "800", fontSize: "18px", margin: 0, color: "#1e293b" }}>
                    Rating Trend
                </h3>
                <div style={{ fontSize: "12px", color: "#64748b", fontWeight: "500" }}>
                    Current Average: {ratingsData.summary.overallRating}/5
                </div>
            </div>

            <div style={{ height: "300px" }}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={ratingsData.trend}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                        <XAxis 
                            dataKey="date" 
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: "#64748b" }}
                            tickFormatter={(value) => {
                                const date = new Date(value);
                                return `${date.getDate()}/${date.getMonth() + 1}`;
                            }}
                        />
                        <YAxis 
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: "#64748b" }}
                            domain={[0, 5]}
                            tickFormatter={(value) => `${value}/5`}
                        />
                        <Tooltip 
                            formatter={(value) => [`${value.toFixed(1)}/5`, "Rating"]}
                            labelFormatter={(label) => `Date: ${label}`}
                            contentStyle={{ 
                                borderRadius: "8px", 
                                border: "1px solid #e2e8f0",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                            }}
                        />
                        <Line
                            type="monotone"
                            dataKey="avgRating"
                            stroke="#f59e0b"
                            strokeWidth={3}
                            dot={{ stroke: "#f59e0b", strokeWidth: 2, r: 4 }}
                            activeDot={{ r: 6, stroke: "#f59e0b", strokeWidth: 2 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            
            <div style={{ 
                marginTop: "16px", 
                fontSize: "12px", 
                color: "#64748b", 
                textAlign: "center",
                fontStyle: "italic"
            }}>
                Showing rating trend over time based on {ratingsData.summary.totalReviews} reviews
            </div>
        </div>
    );

    /* -------------------- RENDER -------------------- */
    return (
        <div style={{ padding: isMobile ? "16px" : "24px" }}>
            <h2 style={{ 
                fontWeight: "800", 
                fontSize: "24px", 
                marginBottom: "24px", 
                color: "#1e293b" 
            }}>
                Ratings & Reviews
            </h2>
            
            <RatingsSummaryCards />
            <RatingsAnalysis />
            <RatingTrendChart />
        </div>
    );
};

export default Ratings;